import React, { FC } from 'react';

import { InverseButton } from '@crehana/ui';

import { useProductsContainer } from '@crehana/web/dist/ReactContexts/Products';

import getEnrollmentUrlWithSource from '../../utils/getEnrollmentUrlWithSource';

interface ITemporalCampaignButton {
  user: any;
  source: string;
  sourceDetail?: string;
  pageId?: number;
  temporalAccessDurationLabel?: string | null;
  courseId?: number;
  isUserSofeAndCourseIsOneMonthOld?: boolean;
  isDark?: boolean;
}

const TemporalCampaignButton: FC<ITemporalCampaignButton> = ({
  user,
  source,
  sourceDetail,
  pageId,
  courseId,
  temporalAccessDurationLabel,
  isUserSofeAndCourseIsOneMonthOld,
  isDark,
}) => {
  const { setBasicDataForm } = useProductsContainer();

  return (
    <InverseButton
      full
      className="mt-16 rounded-10"
      onClick={() => {
        const freeEnrollmentUrl = getEnrollmentUrlWithSource({
          enrollmentUrl: `/enrollment/temporal-access/${pageId}/${courseId}/`,
          source,
          sourceDetail,
        });

        if (user && user.originalId) {
          if (user.phoneNumber) {
            window.location.href = freeEnrollmentUrl;
          } else {
            setBasicDataForm({
              isOpen: true,
              redirectUrl: freeEnrollmentUrl,
            });
          }
        } else {
          window.showRegisterModal(
            freeEnrollmentUrl,
            {},
            {
              isVersion2: true,
            },
            'Course card - temporal access',
          );
        }
      }}
      label={temporalAccessDurationLabel || 'Acceso gratuito por 24 horas'}
      disabled={isUserSofeAndCourseIsOneMonthOld}
      isDark={isDark}
    />
  );
};

export default TemporalCampaignButton;
